import React from "react";
import Nav from "../components/Nav";
import Hero from "../components/Hero";
import Marquee from "../components/Marquee";
import FeaturedIn from "../components/FeaturedIn";
import Brands from "../components/Brands";
import Services from "../components/Services";
import Process from "../components/Process";
import About from "../components/About";
import Highlights from "../components/Highlights";
import HotmartGallery from "../components/HotmartGallery";
import MediaNetwork from "../components/MediaNetwork";
import CaseStudies from "../components/CaseStudies";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import Contact from "../components/Contact";
import SiteFooter from "../components/SiteFooter";

export default function Home() {
  return (
    <main
      data-testid="home-page"
      className="relative min-h-screen bg-[#050505] text-[#f2efe8] selection:bg-[#7FB3D5] selection:text-black"
    >
      <Nav />
      <Hero />
      <Marquee />
      <FeaturedIn />
      <Brands />
      <Services />
      <Process />
      <About />
      <HotmartGallery />
      <Highlights />
      <MediaNetwork />
      <CaseStudies />
      <Testimonials />
      <FAQ />
      <Contact />
      <SiteFooter />
    </main>
  );
}
